import React, {Component} from "react"
import PropTypes from "prop-types"

import Success from "@irati/ui/src/Success"
import {Team} from "@irati/types"
import History from "@irati/utils/history"

import FullModal from "../../FullModal"
import CreateTeamName from "./CreateTeamName"
import AddUsersToTeam from "./AddUsersToTeam"
import ConditionalWrapper from "../../ConditionalWrapper"
import BackLink from "../TeamList/BackLink"
import {VIEW_TEAM} from "../../../routes/routeConfig"

interface Props {
  currentTeam: Team | null
  onHide?: () => void
  show: boolean
  onSuccess?: () => void
  useModal?: boolean
  isSelectTeam: boolean
  hideBackLink?: boolean
}

interface State {
  step: number
  name: string
  currentTeam: Team | null
  isTeamBeingCreated: boolean
}

class CreateTeam extends Component<Props, State> {
  static contextTypes = {
    apps: PropTypes.object.isRequired
  }

  static defaultProps = {
    currentTeam: null,
    show: false,
    useModal: true,
    isSelectTeam: false,
    hideBackLink: false
  }

  getDefaultState = () => {
    const {currentTeam} = this.props
    return {
      step: currentTeam ? 2 : 1,
      name: "",
      currentTeam: currentTeam || null,
      isTeamBeingCreated: false
    }
  }

  state: State = {
    ...this.getDefaultState()
  }

  onEnter = () => {
    if (this.props.onHide) {
      this.props.onHide()
    } else {
      this.setState(this.getDefaultState())
    }
  }

  handleHide = () => {
    const {onHide, useModal} = this.props
    setTimeout(() => {
      if (onHide && useModal) {
        onHide()
      } else {
        this.onEnter()
      }
    }, 2000)
  }

  handleCreateTeam = () => {
    const {onSuccess} = this.props
    this.setState({step: 3})
    if (onSuccess) {
      onSuccess()
    }
    this.handleHide()
  }

  handleAddUsersSuccess = () => {
    this.setState({step: 3})
    this.handleHide()
  }

  renderCurrentStep = () => {
    const {step, currentTeam} = this.state
    const {useModal} = this.props

    switch (step) {
      case 1:
        return <CreateTeamName onSubmit={this.handleCreateTeam} />
      case 2:
        return <AddUsersToTeam currentTeam={currentTeam} onSuccess={this.handleAddUsersSuccess} />
      case 3:
        return <Success withMarginTop={useModal} />
      default:
        return null
    }
  }

  handleBackClick = () => {
    History.push(VIEW_TEAM, this.context.apps.ADMIN)
  }

  render() {
    const {show, onHide, useModal, hideBackLink} = this.props
    return (
      <ConditionalWrapper
        condition={useModal}
        wrapper={(children) => (
          <FullModal show={show} onHide={onHide} onEnter={this.onEnter}>
            {children}
          </FullModal>
        )}>
        {!hideBackLink && <BackLink linkProps={{onClick: this.handleBackClick}} />}
        {this.renderCurrentStep()}
      </ConditionalWrapper>
    )
  }
}

export default CreateTeam
